import {
  Utensils, Music, Landmark, Trees, Palette, Church, ShoppingBag,
  Sparkles, MapPin, Dribbble, Flag, Circle, CircleDot, Goal, Target, Disc,
  Dumbbell, Activity, Zap, Bike, Users,
} from "lucide-react";

// Horse icon isn't in lucide; use a simple emoji-free inline SVG substitute via Sparkles fallback.
const MAP = {
  "Food & Drink": Utensils,
  Entertainment: Music,
  Attractions: Landmark,
  Outdoors: Trees,
  Sports: Dribbble,
  Fitness: Dumbbell,
  Equestrian: MapPin,
  "Arts & Culture": Palette,
  Church: Church,
  Shopping: ShoppingBag,
  Family: Users,
  Other: Sparkles,
};

export const CATEGORY_COLORS = {
  "Food & Drink": "#C0492E",
  Entertainment: "#9B4DCA",
  Attractions: "#2E7D5B",
  Outdoors: "#3B7A3B",
  Sports: "#1F7A8C",
  Fitness: "#C2410C",
  Equestrian: "#8B5E3C",
  "Arts & Culture": "#B8860B",
  Church: "#5B6B8C",
  Shopping: "#C77D4A",
  Family: "#D97706",
  Other: "#7A6A55",
};

export function CategoryIcon({ category, className }) {
  const Icon = MAP[category] || Sparkles;
  return <Icon className={className} />;
}

const SPORT_MAP = {
  Golf: Flag,
  Baseball: Circle,
  Tennis: CircleDot,
  Soccer: Goal,
  Basketball: Dribbble,
  Pickleball: Target,
  "Disc Golf": Disc,
  Gym: Dumbbell,
  Yoga: Activity,
  HIIT: Zap,
  CrossFit: Dumbbell,
  Pilates: Activity,
  Cycling: Bike,
};

export function SportIcon({ sport, className }) {
  const Icon = SPORT_MAP[sport] || Circle;
  return <Icon className={className} />;
}
